import React, { SVGProps } from 'react';

export const ImageGalleryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M22.175 5.015c-.5-.664-1.303-1.077-2.388-1.23L9.226 2.305c-1.085-.153-1.966.022-2.628.521-.664.5-1.078 1.303-1.23 2.386l-.147 1.036h-.554c-2.203 0-3.417 1.213-3.417 3.417v8.668c0 2.204 1.214 3.417 3.417 3.417h10.668c1.909 0 3.072-.914 3.35-2.59 1.56-.126 2.552-1.138 2.811-2.937l1.199-8.58c.155-1.08-.021-1.965-.52-2.628ZM4.667 7.748h10.668c1.362 0 1.918.555 1.918 1.917v5.08l-3.423-3.423a1.644 1.644 0 0 0-2.323 0l-4.173 4.173-.616-.617a1.643 1.643 0 0 0-2.323 0L2.75 16.523V9.665c0-1.362.556-1.917 1.917-1.917ZM15.335 20.25H4.667c-1.256 0-1.82-.48-1.901-1.623l2.689-2.689a.147.147 0 0 1 .202 0l.836.836a1.191 1.191 0 0 0 1.683 0l4.392-4.392a.147.147 0 0 1 .202 0l4.483 4.483v1.468c0 1.362-.556 1.917-1.918 1.917ZM21.21 7.434l-1.199 8.58c-.145 1.005-.525 1.512-1.258 1.637V9.665c0-2.204-1.214-3.417-3.418-3.417h-8.6l.117-.825c.096-.676.313-1.147.648-1.399.332-.251.843-.33 1.516-.234l10.562 1.48c.676.096 1.146.313 1.398.647.252.333.33.843.234 1.517ZM5.517 11.5c0-.552.443-1 .994-1h.008a1 1 0 1 1-1.002 1Z"
    />
  </svg>
);
